import React from "react";
import BaseModal from "../../../components/ui/BaseModal";
import BaseButton from "../../../components/ui/BaseButton";
import BaseEditor from "../../../components/ui/BaseEditor";
import { useMutation } from "@tanstack/react-query";
import { updateUserDetails } from "../../../services/api/user";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/toast/toastSlice";
const MAX_LENGTH = 1000;

const stripHtml = (html) => (html || "").replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ");

const validationSchema = yup.object({
  description: yup
    .string("Enter About me")
    .test(
      "max-length",
      "About me cannot exceed 1000 characters",
      (value) => stripHtml(value).length <= MAX_LENGTH,
    )
    .notRequired("About me not required"),
});
const AddAboutMeModal = ({ open, close, description, refetchMe }) => {
  const dispatch = useDispatch();
  const {
    isPending: isUpdateUserDetailsLoading,
    error: isUpdateUserDetailsError,
    data: updatedUserDetails,
    mutateAsync: updateUserDetailsMutation,
  } = useMutation({
    mutationFn: updateUserDetails,
    enabled: false,
  });

  const formik = useFormik({
    initialValues: {
      description,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleUpdateUserDetails();
    },
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
  });

  const handleUpdateUserDetails = async () => {
    try {
      const userAddressResponse = await updateUserDetailsMutation(formik.values);
      dispatch(
        showToast({
          message: "Added successfully",
          type: "success",
        }),
      );
      refetchMe();
      close(false);
    } catch (error) {}
  };
  const handleClose = () => {
    formik.resetForm({ values: { description } });
    close(false);
  };
  return (
    <form>
      <BaseModal className="-top-[200px] overflow-auto" open={open} close={handleClose}>
        <div className="py-7 px-5 sm:px-12 w-full lg:w-[900px] xl:w-[1000px]">
          <h6 className="text-dark font-normal border-b pb-1">About</h6>

          <div className=" mt-6">
            <p className="font-normal text-base mb-2">About you</p>
          </div>

          <BaseEditor
            value={formik.values.description || ""}
            onChange={(val) => formik.setFieldValue("description", val)}
            showToolbar={true}
            className="rounded-md"
          />
          {formik.touched.description && formik.errors.description && (
            <p className="text-red-500 text-xs mt-1">{formik.errors.description}</p>
          )}
          <div className="flex justify-end">
            <div className="text-sm text-gray-500 mt-1">
              {stripHtml(formik.values.description).length}/{MAX_LENGTH}
            </div>
          </div>
        </div>
        <div
          className="d-flex content-center  bg-white py-6 "
          style={{
            boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.07)",
          }}
        >
          <BaseButton
            className=" px-[28px] py-[5px] bg-light text-primary hover:text-primary"
            variant="outlined"
            color="primary"
            style={{
              marginRight: "16px",
            }}
            onClick={handleClose}
          >
            Cancel
          </BaseButton>

          <BaseButton
            loaderSize="22px"
            isLoading={isUpdateUserDetailsLoading}
            color="primary"
            className="py-[5px] px-[20px]"
            type="submit"
            // Disabled by default; enabled only when there are valid unsaved changes.
            disabled={!formik.dirty || !formik.isValid || isUpdateUserDetailsLoading}
            onClick={formik.handleSubmit}
          >
            Save Changes
          </BaseButton>
        </div>
      </BaseModal>
    </form>
  );
};

export default AddAboutMeModal;
